// Copyright (c) 2016 Deere & Company

import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import {getStore} from '../../../store-factory';
import moment from 'moment';

export const createPipCodeRequestPayload = () => {

    const pipCode = getStore().getState().pips.pipCodeRequest.pipCode;

    const pipProduct = getStore().getState().pips.pipCodeRequest.pipProduct;

    return (
        new PipCode({
            changedBy: pipCode.changedBy,
            createDate: moment.utc().startOf('day').valueOf(),
            createdBy: pipCode.createdBy,
            customerSummary: pipProduct.customerSummary,
            daysRemaining: pipProduct.daysRemaining,
            dealer: pipProduct.responsibleAccount,
            expireDate: pipProduct.expireDate,
            file: pipCode.file,
            internalRecall: pipProduct.internalRecall,
            pin: pipProduct.pin,
            pipCodeType: pipCode.pipCodeType,
            pipId: pipProduct.pipId,
            pipNumber: pipProduct.pipNumber,
            pipStatus: pipProduct.pipStatus,
            pipType: pipProduct.pipType,
            postalDeliveryDate: pipCode.postalDeliveryDate,
            postalTrackingNumber: pipCode.postalTrackingNumber,
            processingStatus: pipCode.processingStatus,
            reasonForRefusal: pipCode.reasonForRefusal,
            refusedDate: pipCode.refusedDate,
            tcsmComments: pipCode.tcsmComments,
            terminationDate: pipProduct.terminationDate,
            territory: pipCode.territory,
            transactionId: pipCode.transactionId,
            witness: pipCode.witness,
            workOrderNumber: pipCode.workOrderNumber
        })
    );

};



// WEBPACK FOOTER //
// ./src/pip/pip-code/services/create-pip-code-request-payload.js